import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

interface SharesChartProps {
  data: Array<{ date: string; count: number }>;
}

export function SharesChart({ data }: SharesChartProps) {
  const chartData = data.map((d) => ({
    label: d.date.slice(5),
    count: d.count,
  }));

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={chartData}>
        <XAxis dataKey="label" stroke="#aaa" fontSize={12} />
        <YAxis stroke="#aaa" fontSize={12} />
        <Tooltip />
        <Line type="monotone" dataKey="count" stroke="#6366f1" strokeWidth={2} dot={false} />
      </LineChart>
    </ResponsiveContainer>
  );
}
